module.exports = __webpack_public_path__ + "img/icon_snyg.96323a8a.png";